import React from 'react';
import { Skeleton } from './skeleton';

export const SkeletonText: React.FC<SkeletonProps> = props => {
  return <Skeleton count={props.count} />;
};

interface SkeletonProps {
  count?: number;
}
